import React from 'react';
import TagSelectionChips, { TagSelectionChipsProps } from './EventContent/TagSelectionChips';
import { Box } from '@mui/material';

type EventInboxTagPanelProps = TagSelectionChipsProps;

const EventInboxTagPanel: React.FC<EventInboxTagPanelProps> = (props) => {
  return (
    <Box
      width="100%"
      height="100%"
      borderLeft="1px solid rgba(0, 0, 0, 0.12)"
      display="grid"
      gridTemplateRows="auto"
      padding="1rem"
    >
      <TagSelectionChips
        {...props}
      />
    </Box>
  )
}

export default EventInboxTagPanel;
